module.exports = __webpack_public_path__ + "static/media/_BID5453.e69e065c.png";